import { useState } from 'react'

export type ON_OFF_AUTO = 'On' | 'Off' | 'Auto'
export type ON_OFF = 'On' | 'Off'
export type ItemsKeysArray = Array<string>

export interface IMapViewSettings {
  sCode: ON_OFF_AUTO
  sName: ON_OFF_AUTO
  sCircle: ON_OFF
  eName: ON_OFF_AUTO
  ePhone: ON_OFF_AUTO
  aDepartment: ON_OFF
  aTeam: ON_OFF
  aNeighborhood: ON_OFF
  aWorkplaceGroup: ON_OFF
  aEWorkplaceGroup: ON_OFF
  aSelectAll: ON_OFF
}

export interface UseMapViewSettingsHook {
  mapViewSettings: IMapViewSettings
  updateMapViewSettings: (
    key: keyof IMapViewSettings,
    value: ON_OFF_AUTO,
    itemsKeys: ItemsKeysArray
  ) => void
}

export default function useMapViewSettings(): UseMapViewSettingsHook {
  const [state, setState] = useState<IMapViewSettings>({
    sCode: 'Auto',
    sName: 'Auto',
    sCircle: 'On',
    eName: 'Auto',
    ePhone: 'Auto',
    aDepartment: 'Off',
    aTeam: 'Off',
    aNeighborhood: 'Off',
    aWorkplaceGroup: 'Off',
    aEWorkplaceGroup: 'Off',
    aSelectAll: 'Off',
  })

  return {
    mapViewSettings: state,
    updateMapViewSettings: (key: string, value: string, itemsKeys: ItemsKeysArray) => {
      let itemObj: { [key: string]: string } = {}

      if (key === 'aSelectAll') {
        if (value === 'On') {
          itemsKeys.forEach((item: string) => {
            itemObj[item] = 'On'
          })
        } else {
          itemsKeys.forEach((item: string) => {
            itemObj[item] = 'Off'
          })
        }
      } else {
        const elementsToRemove = ['aSelectAll', key]
        const newArray = itemsKeys.filter((element: string) => !elementsToRemove.includes(element))
        let values = newArray.map((key: string) => state[key as keyof IMapViewSettings])
        let hasTrueValue = values.every((value: string) => value === 'On')
        if (hasTrueValue && value === 'On') {
          itemObj['aSelectAll'] = 'On'
        } else {
          let anyItemSelected = false

          itemsKeys.forEach((item: string) => {
            itemObj[item] = state[item as keyof IMapViewSettings]

            // Check if any other item is selected
            if (item !== key && state[item as keyof IMapViewSettings] === 'Off') {
              anyItemSelected = false
            }
          })

          // Update 'aSelectAll' based on whether any other item is selected
          itemObj['aSelectAll'] = anyItemSelected ? 'On' : 'Off'
        }

        // Update the selected item
        itemObj[key] = value
      }

      setState({
        ...state,
        ...itemObj,
      })
    },
  }
}
